import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { StatutNotification } from "./statut-notification/statut-notification.model";
import { UserFacade } from "app/main/user/user.facade";
import { User } from "app/main/user/user.model";
import { AppConfigService } from "../service/app-config.service";

declare var SockJS;
declare var Stomp;

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  private stompClient;
  currentUser$: Observable<User>;
  currentUser: User;


  private notificationSubject: Subject<StatutNotification>;

  constructor(private _userFacade: UserFacade,
    private _config: AppConfigService
  ) {
    this.notificationSubject = new Subject<StatutNotification>();
    this._userFacade.getCurrentUser().subscribe(user => {

      this.currentUser = user;

  });
  }

  public connect(): void {
    const socket = new SockJS(`${this._config.config.apiUrl}/ws`);
    socket.withCredentials = true;
    this.stompClient = Stomp.over(socket);
    this.stompClient.connect({}, frame => {
      console.log('Connected to WebSocket');
      console.log(frame);

      this.stompClient.
        subscribe(`/queue/notifications/${this.currentUser.id}`, data => {
          let notification: StatutNotification = JSON.parse(data.body);
          console.log(notification);

          this.notificationSubject.next(notification);
        });
    });
  }

  public disconnect(): void {
    if (this.stompClient) {
      this.stompClient.disconnect();
    }
    console.log('Disconnected from WebSocket');
  }

  getRealTimeNotifications(): Observable<StatutNotification> {
    console.log('getRealTimeNotifications from WebSocket');
    return this.notificationSubject.asObservable();
  }
}